import React from 'react';
import { ArrowRight, Package, KeyRound, Building2, Boxes } from 'lucide-react';
const RELATED = [{
  name: 'Parcel Lockers',
  desc: 'Secure package compartments',
  href: '/6m8/commercial-mailboxes-lockers/parcel-lockers.html',
  Icon: Package
}, {
  name: 'Replacement Commercial Locks, Hinges & Doors',
  desc: 'Repair & replacement hardware',
  href: '/6m8/commercial-mailboxes-lockers/replacement-commercial-locks-hinges-doors.html',
  Icon: KeyRound
}, {
  name: 'Centralized Delivery Mailboxes & Kiosks',
  desc: 'CBU & 4C delivery systems',
  href: '/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-and-kiosks.html',
  Icon: Building2
}, {
  name: 'Commercial Mailboxes & Lockers',
  desc: 'Browse all commercial options',
  href: '/6m8/commercial-mailboxes-lockers.html',
  Icon: Boxes
}];
export function RelatedProducts() {
  return <div className="mt-16 pt-12 border-t border-brand-border" data-id="element-759">
      <div className="flex items-center justify-between mb-8" data-id="element-760">
        <h2 className="text-2xl font-serif font-bold text-brand-charcoal" data-id="element-761">
          Related categories
        </h2>
        <a href="/6m8/commercial-mailboxes-lockers.html" className="hidden sm:flex items-center text-brand-charcoal font-semibold hover:text-brand-maroon transition-colors" data-id="element-762">
          View all commercial <ArrowRight size={16} className="ml-2" data-id="element-763" />
        </a>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6" data-id="element-764">
        {RELATED.map(({
        name,
        desc,
        href,
        Icon
      }) => <a key={name} href={href} className="group bg-white rounded-xl border border-brand-border overflow-hidden hover:shadow-md hover:border-brand-maroon/50 transition-all flex flex-col" data-id="element-765">
            <div className="bg-brand-background/50 aspect-square p-4 border-b border-brand-border/50 flex items-center justify-center text-brand-charcoal/70 group-hover:text-brand-maroon transition-colors" data-id="element-766">
              <Icon size={44} strokeWidth={1.25} data-id="element-767" />
            </div>
            <div className="p-4 flex flex-col flex-grow" data-id="element-768">
              <h3 className="font-bold text-sm text-brand-charcoal group-hover:text-brand-maroon transition-colors mb-1 line-clamp-2" data-id="element-769">
                {name}
              </h3>
              <p className="text-xs text-gray-500 mb-3" data-id="element-770">{desc}</p>
              <span className="text-brand-maroon text-sm font-semibold mt-auto inline-flex items-center" data-id="element-771">
                Shop category <ArrowRight size={14} className="ml-1" data-id="element-772" />
              </span>
            </div>
          </a>)}
      </div>
    </div>;
}